import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';

declare var jQuery:any;
declare var $ :any;
declare var defaultGridViewSettings;
declare var globalConstants;
declare var getGlobalConstantDisplay;
declare var defaultSettingsGrid;

@Component({
  selector: 'accounts-h',
  templateUrl: './accounts-h.component.html',
  styleUrls: ['./accounts-h.component.css'],
})

export class AccountsHistory implements OnInit {

  constructor (private route: ActivatedRoute, private titleService: Title) { }

  ngOnInit() {

    //Set the page title
    this.titleService.setTitle("WiseRisk | Account Event Log");

    $(document).ready(function() {
  			// prepare the data
  			var data = [ {
  				"timestamp" : "5/5/2015 06:08:46.689",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountID" : "45645",
  				"accountCode" : "Account C",
  				"accountGroupCode" : "GR",
  				"baseCcy" : "GBP"
  			}, {
  				"timestamp" : "5/5/2015 06:08:47.577",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountID" : "87879",
  				"accountCode" : "Account D",
  				"accountGroupCode" : "IN",
  				"baseCcy" : "USD"
  			}, {
  				"timestamp" : "5/5/2015 06:08:47.989",
  				"user" : "System",
  				"ipAddress" : "12.56.8.32",
  				"accountID" : "34534",
  				"accountCode" : "Account E",
  				"accountGroupCode" : "IN",
  				"baseCcy" : "USD"
  			} ];

  			var source = {
  				localdata : data,
  				datafields : [ {
  					name : 'timestamp',
  					type : 'string'
  				}, {
  					name : 'user',
  					type : 'string'
  				}, {
  					name : 'ipAddress',
  					type : 'string'
  				}, {
  					name : 'accountID',
  					type : 'string'
  				}, {
  					name : 'accountCode',
  					type : 'string'
  				}, {
  					name : 'accountGroupCode',
  					type : 'string'
  				}, {
  					name : 'baseCcy',
  					type : 'string'
  				} ]
  			};
  			var settings = defaultGridViewSettings("#jqxgrid", source);
  			settings.columns = [ {
  				text : 'Timestamp',
  				columntype : 'textbox',
  				datafield : 'timestamp',
  				width : '160'
  			}, {
  				text : 'User',
  				columntype : 'textbox',
  				datafield : 'user',
  				width : '100'
  			}, {
  				text : 'IP Address',
  				columntype : 'textbox',
  				datafield : 'ipAddress',
  				width : '80'
  			}, {
  				text : 'External Account ID',
  				columntype : 'textbox',
  				datafield : 'accountID',
  				width : '140'
  			}, {
  				text : 'Account',
  				columntype : 'textbox',
  				datafield : 'accountCode',
  				width : '100'
  			}, {
  				text : 'Account Group Code',
  				columntype : 'textbox',
  				datafield : 'accountGroupCode',
  				width : '140'
  			}, {
  				text : 'Base CCY',
  				columntype : 'textbox',
  				datafield : 'baseCcy',
  				width : '80'
  			} ];
  			$("#jqxgrid").jqxGrid(settings);
  		});
  	/*]]>*/
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/history/accounts-h/accounts-h.component.ts